import { MoneyLinkException } from "@/shared/utils/custom-exception";
import { ApiClient } from "@/shared/services/api-client";
import { AddAccountGroupsRequestModel, AddAccountGroupsResponseModel } from "@/features/accounts/account-group/services/add-account-groups-model";

export class AddAccountGroupsApi {
  /**
   * 口座グループ追加
   */
  public addAccountGroup = async (
    param: AddAccountGroupsRequestModel
  ): Promise<AddAccountGroupsResponseModel> => {
    const path = `/api/accountgroups`;
    const res = await ApiClient.instance.post<AddAccountGroupsResponseModel>({
      path: path,
      params: param as NonNullable<unknown>,
    });

    if (res.ok === false) {
      throw MoneyLinkException.fromServer({ response: res });
    }

    return res.body;
  };
}
